import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import * as devConfig from "../app/configs/devConfig";
import { getAuthHeader } from "../app/globalState/GlobalAuthState";
import {
  ActivityCategory,
  ActivityLogEntry,
} from "../features/activityLog/activityLog.types";

export const activityLogSlice = createApi({
  reducerPath: "activityLogSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: `${devConfig.getServerBaseUrlForEnv()}`,
    prepareHeaders: (headers) => {
      const authHeader = getAuthHeader();
      headers.set("Authorization", authHeader.Authorization);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getFirmActivity: build.query<
      ActivityLogEntry[],
      {
        orgId: string;
        category?: ActivityCategory;
        search?: string;
        before?: string;
        take?: number;
      }
    >({
      query: (params) => ({
        url: "api/activity-log/firm",
        params: Object.fromEntries(
          Object.entries(params).filter(([, value]) => !!value),
        ),
      }),
    }),
    getWorkActivity: build.query<ActivityLogEntry[], { workId: string }>({
      query: ({ workId }) => ({
        url: "api/activity-log/work",
        params: { workId },
      }),
    }),
    canViewActivityLog: build.query<boolean, { orgId: string }>({
      query: ({ orgId }) => ({
        url: "api/activity-log/can-view",
        params: { orgId },
      }),
    }),
  }),
});

export const {
  useGetFirmActivityQuery,
  useLazyGetFirmActivityQuery,
  useGetWorkActivityQuery,
  useCanViewActivityLogQuery,
} = activityLogSlice;
